import MainStorage from 'storages/main.storage';
import StorageKeys from 'enum/storages.enum';

function getOrganizationName() {
  return MainStorage.getItem(StorageKeys.Keys.DEVICEREGDATA)?.organization_id?.organization_name;
}

function getGroupWallpapers() {
  return MainStorage.getItem(StorageKeys.Keys.GRPWALLPAPER) ?? [];
}

function getOrganizationIdentity() {
  return MainStorage.getItem(StorageKeys.Keys.ORGANIZATION_IDENTITY);
}

export function getCachedCastingDevices() {
  return MainStorage.getItem(StorageKeys.Keys.CASTING_DEVICES) || [];
}


const obj = { MainStorage, getOrganizationName, getGroupWallpapers, getOrganizationIdentity };

export default obj;
